import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

import { CommonService } from '../../services/common.service';
import { MatDialog } from '@angular/material/dialog';
import { VrmOrderMvrComponent } from '../vrm-order-mvr/vrm-order-mvr.component';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'grid-order-mvr-button',
  template: `
    <span>
      <button
        mat-button
        vrm-button
        fxFlex
        class="grid-text-centred force grid-text"
        style="color: white"
        (click)="triggerLinkButtonAction()"
      >
        {{ value }}
      </button>
    </span>
  `,
  styles: [],
})
export class GridOrderMvrLinkButtonComponent implements ICellRendererAngularComp {
  public value: string;
  private rowData: any;

  constructor(private cService: CommonService, private dialog: MatDialog) {}

  public agInit(params: { data: any; value: any }): void {
    this.value = this.cService.toVrmCaps(params.value);
    this.rowData = params.data;
  }

  public triggerLinkButtonAction(): void {
    if (this.cService.userProfile.userPermissions.permUsMvr === 'view_edit') {
      if (this.rowData?.licenseState && !this.rowData?.mvrOrderOptions) {
        this.loadStateOptions().subscribe({ next: () => this.openPopup() });
        return;
      }

      this.openPopup();
    } else {
      this.cService.showToast(
        this.cService.getSingleTranslation(
          'MESSAGESANDWARNINGS.insufficientPermissionToViewRequestedPage',
          'You have insufficient permission to view the requested page'
        ),
        3000
      );
    }
  }

  private loadStateOptions(): Observable<any> {
    return this.cService.commonGet(`mvr/order/options/${this.rowData.licenseState}`).pipe(
      tap((response: any) => {
        this.rowData.mvrOrderOptions = response.options;
      })
    );
  }

  private openPopup(): void {
    this.dialog.open(VrmOrderMvrComponent, {
      maxWidth: this.cService.isMobileViewport ? '100%' : '40%',
      data: { ...this.rowData },
    });
  }

  public refresh(): boolean {
    return false;
  }
}
